import * as martinez from 'martinez-polygon-clipping';
import { isNonNullish } from '@salsita-ai/platform-common/utils';
import { createCirclePolygon, createRectPolygon } from './shapes.js';
import { findCircleIntersections } from './utils.js';
export const createPN6HolePolygon = (hole)=>{
    const { $absCoords: { x, y }, width, height, sideRadius: smallCircleRadius, joinRadius } = hole;
    const largeCircle = {
        center: {
            x,
            y
        },
        radius: height / 2
    };
    const smallCircles = [
        -1,
        1
    ].map((direction)=>({
            center: {
                x: x + direction * (width / 2 - smallCircleRadius),
                y
            },
            radius: smallCircleRadius
        }));
    const largeCirclePolygon = createCirclePolygon(largeCircle);
    const smallCirclePolygons = smallCircles.map((smallCircle)=>createCirclePolygon(smallCircle));
    const largeIntersectionCircle = {
        center: largeCircle.center,
        radius: largeCircle.radius + joinRadius
    };
    const middleCutoutPolygons = smallCircles.reduce((acc, smallCircle)=>{
        const smallIntersectionCircle = {
            center: smallCircle.center,
            radius: smallCircle.radius + joinRadius
        };
        const cutouts = findCircleIntersections(largeIntersectionCircle, smallIntersectionCircle).map((middleCircleCenter)=>{
            const middleCircle = {
                center: middleCircleCenter,
                radius: joinRadius
            };
            const [largeMiddleCirclesIntersection] = findCircleIntersections(largeCircle, middleCircle);
            const [smallMiddleCirclesIntersection] = findCircleIntersections(smallCircle, middleCircle);
            if (!largeMiddleCirclesIntersection || !smallMiddleCirclesIntersection) {
                return null;
            }
            const middleCirclePolygon = createCirclePolygon(middleCircle);
            const middleRectWidth = smallMiddleCirclesIntersection.x - x;
            const middleRectHeight = largeMiddleCirclesIntersection.y - y;
            const middleRectPolygon = createRectPolygon({
                center: {
                    x: x + middleRectWidth / 2,
                    y: y + middleRectHeight / 2
                },
                width: Math.abs(middleRectWidth),
                height: Math.abs(middleRectHeight)
            });
            return martinez.diff(middleRectPolygon, middleCirclePolygon);
        }).filter(isNonNullish);
        return [
            ...acc,
            ...cutouts
        ];
    }, []);
    const allPolygons = [
        largeCirclePolygon,
        ...smallCirclePolygons,
        ...middleCutoutPolygons
    ];
    return allPolygons.reduce(martinez.union);
};

//# sourceMappingURL=pn6-hole.js.map